import React from 'react'
import { Typography, Section, SubSection } from './partials'
import { maroon, midBlue } from '../../colors';
import PageBannerComponent from "../../shared/components/pageBanner";

import product1 from '../../assets/img/products/img1.png';
import product2 from '../../assets/img/products/img3.png';
import avicollect from '../../assets/img/products/avicollect.png';
import bda from '../../assets/img/products/bda.png';
import cargo from '../../assets/img/products/cargo.png';
import serviceIcon from '../../assets/img/products/service.png';
import ebips from '../../assets/img/products/EBIPS png.png'

// import bdaBrochure from '../../assets/brochures/EBIPS_Brochure.pdf'
import avitechBrochure from '../../assets/brochures/Avitech_Sotware_Solutions_Brochure.pdf'
const styles = {
    productHeading: {
        color: '#111',
        marginBottom: '0px',
        textTransform:'uppercase',
        fontFamily: 'Montserrat',
        fontWeight: 100
    },
    productHeadingAlt: {
        textTransform:'uppercase',
        fontFamily: 'Montserrat',
        color: '#fff',
        marginBottom: '0px',
        fontWeight: 100
    },
    productSubHeading: {
        color: '#8c1922',
        textAlign: 'left',
        paddingTop: '10px',
        lineHeight: 1.5
    },
    productSubHeadingAlt: {
        color: '#fff',
        lineHeight:1.5,
    },
    row: {
      padding: '40px 0'
    },
    btnCover:{
    padding: '20px 0',
    borderBottom: '1px solid #21212114'
},
    btn: {
        padding: '8px 25px',
        borderColor: '#8c1922',
        color: '#8c1922'
    },
    h1Heading:{
        textAlign: 'center',
        color:'#111',
        textTransform:'upper-case',
        marginBottom:'50px',
        fontFamily: 'Montserrat',
        fontWeight: 200,fontSize:'45px'
    }

};

const ProductsPage = () => {
    return (
        <div>
            <PageBannerComponent title='Products & Services' subTitle=''/>

            <div className='container-fluid'>
                <div>



                    <div className="container our-journey">
                        <div className="row" style={styles.row}>
                            <div className="col-md-6">
                                <SubSection>
                                    <h2 style={styles.productHeading}> Billing Data Aggregator</h2>
                                    <div variant='paragraph' align='justify'>
                                        <h5 className={'mb-4 mt-3'} style={styles.productSubHeading}>
                                            From manual bills to e-bills
                                            <br/>Separate debtors from creditors in real time.
                                        </h5>
                                        <p>
                                            EBIPS is the ultimate billing and payment settlement suite; to improve transparency and business accountability, which eventually results in increased cash flow as well as better  business intelligence for organizations.
                                        </p>
                        </div>

                                </SubSection>
                            </div>
                            <div className="col-md-6">
                                <img src={ebips} alt="" className='img-fluid'/>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ ...styles.row, backgroundColor: maroon, color: 'white' }}>
                        <div className='container our-journey'>
                            <div className='row'>
                                <div className="col-md-6">
                                    <img src={avicollect} alt="" className='img-fluid'/>
                                </div>
                                <div className="col-md-6">
                                    <SubSection>
                                        <h2 style={styles.productHeadingAlt}> AviCollect</h2>
                                        <div variant='paragraph' align='justify'>
                                            <h5 className={'mb-4 mt-3'} style={styles.productSubHeadingAlt}>
                                                Domestic and International
                                                <br/>Aggregate and Process Passenger Information
                                            </h5>
                                            <p className={'mb-4'}>
                                                Real-time data processing center for all passenger information across countries. The systems’ data accuracy enhances payment automation and cash flow predictability. All with minimal efforts.
                                            </p>
                                        </div>

                                    </SubSection>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="container our-journey">
                        <div className="row" style={styles.row}>
                            <div className="col-md-6">
                                <SubSection>
                                    <h2 style={styles.productHeading}> Business Intelligence Dashboard</h2>
                                    <div variant='paragraph' align='justify'>
                                        <h5 className={'mb-4 mt-3'} style={styles.productSubHeading}>
                                            Single view for financial and operational data.
                                        </h5>
                                        <p className={'mb-4'}>
                                            Data management and visualization platform to transform your data into interactive and useful information. This exceptional platform leverages present and historic data from integrated systems to influence decisions for increased profitability. View your debtors, creditors, field operations statistics in real- time, everytime.
                                        </p>
                                    </div>
                                </SubSection>
                            </div>
                            <div className="col-md-6">
                                <img src={product1} alt="" className='img-fluid'/>

                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ ...styles.row, backgroundColor: midBlue, color: 'white' }}>
                        <div className='container our-journey'>
                            <div className='row'>
                                <div className="col-md-6">
                                    <img src={cargo} alt="" className='img-fluid'/>
                                </div>
                                <div className="col-md-6">
                                    <SubSection>
                                        <h2 style={styles.productHeadingAlt}> Cargo Management System</h2>
                                        <div variant='paragraph' align='justify'>
                                            <h5 className={'mb-4 mt-3'} style={styles.productSubHeadingAlt}>
                                                From data validation to payment processing
                                            </h5>
                                            <p className={'mb-4'}>
                                                Carefully designed system for cargo data integration and bills processing. The system’s multi-check capability through integration with global ASYCUDA guarantees data accuracy anywhere in the world. All eliminating the errors involved  and effort spent in processing payment.
                                            </p>
                                        </div>
                                    </SubSection>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="container our-journey">
                        <div className="row" style={styles.row}>
                            <div className="col-md-6">
                                <SubSection>
                                    <h2 style={styles.productHeading}>Digital Airport Management</h2>
                                    <div variant='paragraph' align='justify'>
                                        <h5 className={'mb-4 mt-3'} style={styles.productSubHeading}>
                                            Bespoke data collection systems for operational insight and accurate billing to block revenue leakages.
                                        </h5>
                                        <p>
                                            Features:
                                        </p>
                                        <ol>
                                            <li>
                                                Domesticated Global solutions.
                                            </li>
                                            <li>
                                                Detailed understanding of the operational environment.
                                            </li>
                                            <li>
                                                Unified Electronic Invoicing platform.
                                            </li>
                                            <li>
                                                Vehicle data capture systems & Energy Management Systems.
                                            </li>
                                            <li>
                                                OEM partnerships.
                                            </li>
                                            <li>
                                                Proprietary Systems.
                                            </li>
                                        </ol>
                        </div>

                                </SubSection>
                            </div>
                            <div className="col-md-6">
                                <img src={product2} alt="" className='img-fluid'/>

                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ ...styles.row, backgroundColor: maroon, color: 'white' }}>
                        <div className='container our-journey'>
                            <div className='row'>
                                <div className="col-md-6">
                                    <img src={avicollect} alt="" className='img-fluid'/>
                                </div>
                                <div className="col-md-6">
                                    <SubSection>
                                        <h2 style={styles.productHeadingAlt}> Flight Information System</h2>
                                        <div variant='paragraph' align='justify'>
                                            <h5 className={'mb-4 mt-3'} style={styles.productSubHeadingAlt}>
                                                Make payment and reconciliation faster with one-click.
                                            </h5>
                                            <p>
                                                Features:
                                            </p>
                                            <ol>
                                                <li>
                                                    IOT technology for data capture solutions.
                                                </li>
                                                <li>
                                                    ADSB for flight data.
                                                </li>
                                                <li>
                                                    End to end digitized billing, invoicing & payment solution
                                                </li>
                                                <li>
                                                    Automated revenue collection
                                                </li>
                                                <li>
                                                    Digitized data to payments
                                                </li>
                                            </ol>
                                        </div>
                                    </SubSection>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className={'container'} style={styles.btnCover}>
                        <div className="row">
                            <div className="col-md-12">
                                <a download href={avitechBrochure} className={'btn'} style={{background:'#8c1922',color:'white'}}>
                                    Download Brochure
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
                <Section>
                    <div className="container">
                        <div>
                            <h1 style={styles.h1Heading}>Our Services</h1>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <SubSection>
                                    <div className="text-center pb-3">
                                        <img src={serviceIcon} alt="" style={{width: '50px'}}/>
                                    </div>
                                    <Typography variant='subTitle' align='center' color={maroon}>
                                        <div style={{margin:'20px 0',fontFamily: 'Montserrat',  fontWeight: 100}}>  Revenue Assurance and Maximization Services</div>
                                    </Typography>
                                    <div variant='paragraph' align='justify'>
                                        <p>
                                        Whether our clients are looking for payment transparency and revenue assurance or opportunities to increase their revenue via optimization, we help our clients proffer solutions to revenue collection challenges through our intelligent approach to automation and revenue maximization.
                                        </p>
                                    </div>

                                </SubSection>
                            </div>
                            <div className="col-md-4">
                                <SubSection>
                                    <div className="text-center pb-3">
                                        <img src={serviceIcon} alt="" style={{width: '50px'}}/>
                                    </div>
                                    <Typography variant='subTitle' align='center'  color={maroon}>
                                        <div style={{margin:'20px 0',fontFamily: 'Montserrat',  fontWeight: 100}}>   Airport Management Services</div>
                                    </Typography>
                                    <div variant='paragraph' align='justify'>
                                        <p>
                                        Our Digital Airport Management system automates all aviation related operations to ensure efficiency and accurate data capture resulting in increased safety and security, revenue automation and transparency.
                                        </p>
                                    </div>

                                </SubSection>
                            </div>
                            <div className="col-md-4">
                                <SubSection>
                                    <div className="text-center pb-3">
                                        <img src={serviceIcon} alt="" style={{width: '50px'}}/>
                                    </div>
                                    <Typography variant='subTitle' align='center' color={maroon}>
                                        <div style={{margin:'20px 0',fontFamily: 'Montserrat',  fontWeight: 100}}>   Business Intelligence Services</div>
                                    </Typography>
                                    <div variant='paragraph' align='justify'>
                                        <p>
                                            We help companies transform their data into cash by leveraging on software and services to transform data into actionable intelligence that informs strategic and tactical business decisions.
                                            Our services provide access to analytical findings in reports, summaries, dashboards, graphs, charts and maps to provide detailed information about the state of their business.
                                        </p>
                                    </div>

                                </SubSection>
                            </div>
                        </div>
                    </div>

                </Section>

                </div>

        </div>

    );
}

export default ProductsPage;



// WEBPACK FOOTER //
// ./src/views/products/index.jsx